var character = "Karakter";
var copied = "Sudah disalin";
var copy = "Salin";
var insert = "Masukkan";
var loading = "Memuat";
var orCopyLink = "Atau salin link";
var submit = "Submit";
var idTranslations = {
	"actionPopover.delete": "Hapus",
	"actionPopover.deleteNotification": "Hapus Notifikasi Ini",
	"actionPopover.edit": "Edit",
	"actionPopover.inviteShareCommunity": "Undang/Bagikan Komunitas",
	"actionPopover.joinCommunity": "Gabung dengan Komunitas",
	"actionPopover.leaveCommunit": "Keluar Komunitas",
	"actionPopover.leaveCommunity": "Keluar Komunitas",
	"actionPopover.leaveCommunity.accept": "Leave",
	"actionPopover.leaveCommunity.cancel": "Cancel",
	"actionPopover.leaveCommunity.description": "Anda yakin keluar dari komunitas ini?",
	"actionPopover.leaveCommunity.title": "Keluar dari komunitas",
	"actionPopover.report": "Laporkan",
	"actionPopover.turnOffNotification": "Matikan notifikasi",
	"actionPopover.turnOffNotificationAbout": "Matikan notifikasi tentang {label}",
	"actionPopover.turnOnNotification": "Nyalakan notifikasi",
	"adBanner.title": "Iklan",
	"admin.comments": "Komentar",
	"admin.communities": "Komunitas",
	"admin.community": "Komunitas",
	"article.shareOn": "Bagikan ",
	"articleAuthor.title.expert": "Expertly reviewed by",
	"articleAuthor.title.fact-check": "Fakta medis diperiksa oleh {name}",
	"articleAuthor.title.medical": "Medically reviewed by",
	"articleAuthor.title.written-by": "Written by",
	"articlePage.articleReviewerBy": "Ditinjau oleh {name}",
	"articlePage.readMore": "Lanjut",
	"articlePage.showLess": "Tampilkan lebih sedikit",
	"babyGrowth.alert.bmi": "Tidak ada pengukuran BMI yang ditampilkan untuk {name} dalam rentang data WHO dari usia 0 hingga 5 tahun. Gunakan alat kalkulator BMI di atas usia 5 tahun.",
	"babyGrowth.alert.head": "Tidak ada pengukuran lingkar kepala yang ditampilkan untuk {name} dalam rentang data WHO dari usia 0 hingga 5 tahun.",
	"babyGrowth.alert.weight": "Tidak ada pengukuran berat badan yang ditampilkan untuk {name} dalam rentang data WHO dari usia 0 hingga 10 tahun.",
	"babyGrowth.babyInfo": "Informasi Bayi",
	"babyGrowth.chartTitle": "WHO - Kurva Pertumbuhan {name}",
	"babyGrowth.chartTitle.noName": "Grafik pertumbuhan anak Anda",
	"babyGrowth.cm": "cm",
	"babyGrowth.drawer.addMeasurement": "Tambahkan Pengukuran",
	"babyGrowth.drawer.createBaby": "Buat Profil Anak",
	"babyGrowth.drawer.switchProfile": "Ganti Profil",
	"babyGrowth.emptyName": "anak Anda",
	"babyGrowth.error.atLeastOneOf": "Harus diisi salah satunya terlebih dahulu: Berat Badan, Panjang/Tinggi Badan, Lingkar Kepala",
	"babyGrowth.error.birthdayRequired": "Tanggal lahir harus diisi",
	"babyGrowth.error.invalidAge": "Pengukuran melebihi umur.",
	"babyGrowth.error.invalidMeasurementDate": "Hari yang ditentukan tidak tepat.",
	"babyGrowth.error.invalidValue": "Masukkan info yang tepat",
	"babyGrowth.error.measurementDateLowerThanBirthday": "Tanggal yang dimasukkan adalah sebelum tanggal lahir anak Anda",
	"babyGrowth.error.outOfRange": "Pengukuran melebihi jangkauan data WHO.",
	"babyGrowth.error.title": "Data tidak valid",
	"babyGrowth.head": "Lingkar Kepala",
	"babyGrowth.headCircumference": "Ukuran Lingkar Kepala",
	"babyGrowth.height": "Panjang Badan",
	"babyGrowth.input.babyName": "Nama Anak",
	"babyGrowth.input.birthday": "Tanggal Lahir Anak",
	"babyGrowth.input.bmi": "Indeks Massa Tubuh (BMI)",
	"babyGrowth.input.bodyMass": "Indeks Massa Tubuh (BMI)",
	"babyGrowth.input.checkSubmit": "Pantau Pertumbuhan Anak Anda",
	"babyGrowth.input.measurementDate": "Tanggal Pengukuran",
	"babyGrowth.input.submit": "Pantau Pertumbuhan Anak Anda",
	"babyGrowth.kg": "kg",
	"babyGrowth.kg.m2": "kg/m2",
	"babyGrowth.monthly": "Bulanan",
	"babyGrowth.nickname": "Nama Panggilan",
	"babyGrowth.optional": "(opsional)",
	"babyGrowth.pageTitle": "Hasil Pertumbuhan Anak Anda",
	"babyGrowth.percentiles": "Persentil",
	"babyGrowth.placeholder.babyName": "Tambahkan Nama Anak",
	"babyGrowth.popup.heading": "Baby's Profile",
	"babyGrowth.reCalculate": "Hitung Ulang",
	"babyGrowth.record": "Data Tersimpan",
	"babyGrowth.save": "Simpan Pengukuran",
	"babyGrowth.save.loggedIn": "Grafik Pertumbuhan {name}",
	"babyGrowth.weekly": "Mingguan",
	"babyGrowth.weight": "Berat Badan",
	"babyGrowth.xLabel": "Umur ({recurrence})",
	"babyGrowth.yearly": "Tahunan",
	"babyPoop.findOut": "Temukan",
	"babyPoopTool.name": "Feses Bayi",
	"babyVaccine.banner.readmore": "Baca lebih banyak",
	"babyVaccine.detail.benifit": "Manfaat",
	"babyVaccine.detail.contraindication": "Kontraindikasi",
	"babyVaccine.detail.definition": "Definisi",
	"babyVaccine.detail.relatedArticles": "Artikel Terkait",
	"babyVaccine.immunization.vaccineName": "Nama vaksin ",
	"babyVaccine.immunization.warning": "Jadwal imunisasi ini mudah dibaca dan ramah untuk orang tua karena serupa dengan jadwal imunisasi anak Anda. ",
	"babyVaccine.popup.button": "Create a new profile",
	"babyVaccine.popup.button.submit": "Simpan",
	"babyVaccine.popup.checkbox.suggestedDate": "Pilih tanggal vaksinasi atau pertahankan sesuai saran di bawah ini.",
	"babyVaccine.popup.confirm.close": "Ganti tanggal",
	"babyVaccine.popup.confirm.description": "Bayi Anda sudah diberikan vaksin ini pada {date}",
	"babyVaccine.popup.confirm.ok": "Mengonfirmasi",
	"babyVaccine.popup.confirm.title": "Tanggal vaksinasi",
	"babyVaccine.popup.input.suggestedDate": "Saya tidak ingat/atur sebagai tanggal yang disarankan ",
	"babyVaccine.popup.label.doses": "Dosis",
	"babyVaccine.popup.tab.benefits": "Manfaat",
	"babyVaccine.popup.tab.contraindication": "Kontraindikasi",
	"babyVaccine.popup.tab.detail": "Selengkapnya",
	"babyVaccine.popup.tab.schedule": "Pelacakan",
	"babyVaccine.popup.title": "Informasi vaksin",
	"babyVaccine.status.all": "Semua",
	"babyVaccine.status.missed": "Terlewat",
	"babyVaccine.status.next": "Next",
	"babyVaccine.status.upcoming": "Selanjutnya",
	"babyVaccine.status.vaccinated": "Sudah Divaksinasi",
	"babyVaccine.timeline.antigen": "Antigen:",
	"babyVaccine.timeline.atBirth": "Saat lahir",
	"babyVaccine.timeline.total": "Total {nomor} dosis",
	"babyVaccine.timeline.totalNext": "Dosis selanjutnya {nomor}",
	"babyVaccine.timeline.totalPast": "Dosis sebelumnya {nomor}",
	"babyVaccine.vaccineCard.injected": "Divaksin ",
	"babyVaccine.vaccineCard.markAsInjected": "Tandai sebagai sudah divaksin ",
	"babyVaccine.vaccineInfo.dose": "Dosis ",
	"babyVaccine.vaccineInfo.injectedDate": "Tanggal vaksin ",
	"babyVaccine.vaccineInfo.mandatory": "Vaksin Dasar",
	"babyVaccine.vaccineInfo.optional": "Opsional (Pilihan)",
	"babyVaccine.vaccineInfo.suggested": "Rekomendasi tanggal: {date}",
	"babyVaccineTool.heading": "Pengingat Jadwal Imunisasi Bayi dan Anak",
	"bmi.ageInput": "Berapa usia Anda?",
	"bmi.ageInput.desc": "(tahun)",
	"bmi.ageInput.error": "Masukkan usia yang valid.",
	"bmi.heading": "Kalkulator BMI (IMT)",
	"bmi.heightInput": "Berapa tinggi Anda?",
	"bmi.heightInput.desc": "(cm)",
	"bmi.heightInput.error": "Masukkan tinggi badan yang valid.",
	"bmi.objective": "Tujuan",
	"bmi.objective.gainWeight": "Membangun otot",
	"bmi.objective.loseWeight": "Menghilangkan lemak",
	"bmi.objective.maintainWeight": "Menjaga berat badan",
	"bmi.result.healthy": "Sehat",
	"bmi.result.overweight": "Kelebihan Bobot",
	"bmi.result.underweight": "Kekurangan Bobot",
	"bmi.selectGender": "Apa jenis kelamin Anda?",
	"bmi.submit": "Hitung",
	"bmi.weightInput": "Berapa berat badan Anda?",
	"bmi.weightInput.desc": "(kg)",
	"bmi.weightInput.error": "Masukkan berat badan yang valid.",
	"bmr.heading": "Kalkulator Kebutuhan Kalori",
	"booking.searchBar.allLocations": "Semua Lokasi",
	"booking.searchBar.allSpecialties": "Semua Spesialisasi",
	"booking.searchBar.currentLocation": "Lokasi saat ini",
	"booking.searchBar.grantLocation": "Izinkan kami membantu pencarian lewat lokasi terbaru Anda",
	"booking.searchBar.locationPlaceholder": "Kota",
	"booking.searchBar.noResults": "Tidak Ada Hasil",
	"booking.searchBar.placeholder.doctor": "Cari berdasarkan nama dokter",
	"booking.searchBar.placeholder.hospital": "Cari berdasarkan nama rumah sakit",
	"booking.searchBar.placeholder.service": "Cari berdasarkan layanan",
	"booking.searchBar.placeholder.specialty": "Cari berdasarkan Spesialisasi atau Rumah Sakit",
	"booking.searchBar.popularKey": "Pencarian Populer",
	"booking.searchBar.searchButton": "Cari",
	"booking.searchBar.searchInput.placeholder": "Cari berdasarkan Spesialisasi atau Rumah Sakit...",
	"booking.searchBar.useCurrentLocation": "Gunakan posisi saya saat ini",
	"booking.searchBar.viewAll": "Lihat Semua",
	"booking.searchPopup.doctors": "Dokter",
	"booking.searchPopup.hospitals": "Rumah sakit & Klinik",
	"booking.searchPopup.searchIn.doctors": "Cari \"{name}\" dari daftar Dokter",
	"booking.searchPopup.searchIn.hospitals": "Cari \"{name}\" dari daftar Rumah Sakit",
	"booking.searchPopup.searchIn.services": "Lihat \"{name}\" di dalam Layanan",
	"booking.searchPopup.searchIn.specialties": "Cari \"{name}\" di dalam Spesialisasi",
	"booking.searchPopup.seeAll": "Lihat Semua",
	"booking.searchPopup.seeLessSpecialties": "Lihat lebih sedikit spesialisasi",
	"booking.searchPopup.seeMoreSpecialties": "Lihat Semua Spesialisasi",
	"booking.searchPopup.services": "Layanan",
	"booking.searchPopup.specialties": "Spesialisasi",
	"booking.searchResult.description": "{search_type} di {search_location}",
	"bottomBar.share": "Bagikan",
	"cardAuthor.admin": "Admin",
	"cardAuthor.ambassador": "Duta",
	"cardAuthor.expert": "Dokter",
	"cardAuthor.guide": "Panduan",
	"cardAuthor.influencer": "Influencer",
	"cardAuthor.localAdmin": "Admin Lokal",
	"cardAuthor.moderator": "Moderator",
	"cardAuthor.sponsor": "Sponsor",
	"cardPost.anonymous": "Anonim ",
	"cardPost.option.anonymous": "Anonim",
	"cardPost.public": "Publik",
	"cardReactions.comment": "Komentar",
	"cardReactions.like": "Suka",
	"cardReactions.repliesCount": "{count} balasan",
	"cardReactions.reply": "Balas",
	"cardReactions.save": "Simpan",
	"cardReactions.unSave": "Tidak Simpan",
	"cardReply.disclaimer": "<strong>Disclaimer:</strong> Informasi yang disampaikan di atas adalah informasi umum, bukan pengganti saran medis resmi dari dokter atau pakar.",
	"cardReply.endorse": "Endorse",
	"cardReply.opposePopup.content": "Can you please provide the reasons for refuting this answer?",
	"cardReply.opposePopup.submit": "Submit",
	"cardReply.pppose": "Refute",
	"cardReply.recommentCategories.heading": "Related content",
	"cardReply.source": "Sources",
	"cardReply.verifyBy": "Medically reviewed by {name}",
	"careBooking.bookAnAppointment": "Buat Janji Temu",
	"categoryPage.info.reviewed": "Ditinjau oleh",
	"categoryPage.onDate": "pada {date}",
	character: character,
	"chatbot.with.me": "Chat dengan saya",
	"childCard.age.months": "{month} bulan",
	"childCard.age.oneMonth": "1 bulan",
	"childCard.age.oneWeek": "1 minggu",
	"childCard.age.oneYear": "1  tahun",
	"childCard.age.oneYearMonth": "1  tahun {month} bulan",
	"childCard.age.oneYearOneMonth": "1 tahun 1 bulan",
	"childCard.age.week": "{weeks} minggu",
	"childCard.age.yearMonth": "{year}  tahun {month} bulan",
	"childCard.age.yearNoMonth": "{year} tahun",
	"childCard.age.yearOneMonth": "{year} tahun 1 bulan",
	"childCard.boy": "Laki-laki",
	"childCard.girl": "Perempuan",
	"childCard.menu.add": "Tambahkan Profil Anak",
	"childCard.menu.edit": "Ubah Profil {name}",
	"childCard.menu.remove": "Hapus Profil {name}",
	"childCard.menu.switch": "Ganti Profil ",
	"childCard.noName": "Nama Anak",
	"choicePopover.ambassadorPosts": "Postingan Duta Sehat",
	"choicePopover.expertPosts": "Postingan Pakar",
	"choicePopover.lastestPost": "Postingan terakhir",
	"choicePopover.latest": "Terbaru",
	"choicePopover.newest": "Terbaru",
	"choicePopover.oldest": "Terlama",
	"choicePopover.popular": "Populer",
	"choicePopover.popularPost": "Postingan terpopuler",
	"choicePopover.sort": "Urutkan",
	"choose.community": "Pilih komunitas Anda",
	"choose.other.community": "Pilih komunitas lain",
	"chooseBaby.button": "Lihat Grafik Pertumbuhan Anak Anda",
	"chooseBaby.new": "Atau tambahkan profil anak",
	"chooseBaby.placeholder": "Mohon isi nama anak",
	"chooseBaby.title": "Pilih Profil Anak",
	"comment.count": "{count} komentar",
	"comment.now": "Komentar sekarang",
	"comment.seeMoreComments": "Lihat {count} komentar lain",
	"comment.seeMoreReplies": "Lihat {count} balasan untuk Anda",
	"commentPopup.warning.newPost": "Semua orang bisa melihat pertanyaanmu",
	"common.playing": "Memutar ...",
	"common.profileNavigator.newsletterSubscription": "Newsletter Subscription",
	"common.sponsoredBy": "Disponsori Oleh",
	"common.totalView": "{number} tampilan",
	"community.choose": "Pilih komunitas",
	"community.notification.joined": "Anda bergabung di komunitas {name}",
	"community.notification.left": "Anda keluar dari komunitas {name}",
	copied: copied,
	copy: copy,
	"createPost.askDoctor": "Tanya Dokter",
	"createPost.askDoctor.description": "Dapatkan saran dari ahli kami",
	"createPost.askDoctorChoice.no": "No",
	"createPost.askDoctorChoice.yes": "Yes",
	"createPost.communityAndTopic": "Komunitas & Topik",
	"createPost.message.askDoctorRequire": "Would you like to ask a question to our doctor?",
	"createPost.message.askDoctorRequireMess": "Silakan pilih opsi",
	"createPost.message.lengthDescription": "Deskripsi harus memiliki setidaknya 10 kata | Saat ini: {currentLength} kata",
	"createPost.message.lengthTitle": "Judul harus memiliki setidaknya 5 kata",
	"createPost.message.lengthTitle.characters": "Judul harus memiliki setidaknya 5 karakter.",
	"createPost.message.photoMaxium": "Maksimal 10 gambar saat mengunggah gambar untuk postingan",
	"createPost.message.photoSize": "Hanya diperbolehkan mengunggah gambar dengan ukuran <= 10 MB",
	"createPost.message.requiredDescription": "Deskripsi diperlukan",
	"createPost.message.requiredTitle": "Judul diperlukan",
	"createPost.message.suggestLoading": "Kami sedang menyarankan komunitas yang relevan untuk postingan Anda",
	"createPost.message.suggestResult": "Anda sudah bisa memposting sekarang! Kami akan terus mencari komunitas yang relevan setelah itu",
	"createPost.now": "Posting sekarang",
	"createPost.photos": "Foto",
	"createPost.popup.description": "Deskripsi",
	"createPost.popup.guideSelectMonthTopics": "Pilih topik tentang bulan kelahiran bayi Anda",
	"createPost.popup.guideSelectTopics": "Pilih topik, tempat memposting artikel Anda",
	"createPost.popup.primary": "Klik untuk pilih atau hapus topik",
	"createPost.popup.selectMonthTopicBtn": "Pilih",
	"createPost.popup.specialCharErr": "Judul yang Anda masukkan tidak valid. Judul harus mengandung huruf.",
	"createPost.popup.submit": "Unggah",
	"createPost.popup.success": "Postingan Baru Berhasil",
	"createPost.popup.warning": "Pilih komunitas untuk lihat postingan yang Anda ikuti",
	"createPost.popup.warningImage": "Maximum 20 images allow, please remove some item below",
	"createPost.popup.wordCount": "{count}/{max} jumlah kata",
	"createPost.post.askDoctor.description": "Deskripsikan gejala",
	"createPost.post.askDoctor.title": "Nama gejala",
	"createPost.post.description": "Deskripsi postingan",
	"createPost.post.title": "Judul postingan",
	"createPost.postAnonymous": "Pos anonim",
	"createPost.title": "Title",
	"createPost.urlText": "Text",
	"createPost.video": "Video",
	"createPost.videoOrLink": "Video atau tautan",
	"dueDatePage.IUI": "Inseminasi Buatan (IUI)",
	"dueDatePage.calculationMethod": "Metode kalkulasi",
	"dueDatePage.conceptionDate": "Tanggal Pembuahan",
	"dueDatePage.date_of_IUI_procedure": "Tanggal prosedur IUI",
	"dueDatePage.date_of_ultrasound": "Tanggal USG",
	"dueDatePage.daysText": "{number} days",
	"dueDatePage.ivf": "Program Bayi Tabung",
	"dueDatePage.ivf.transferDate": "Tanggal Pemindahan Bayi Tabung",
	"dueDatePage.ivf.transferDateRadio": "{number} Hari Pemindahan",
	"dueDatePage.lastPeriod": "Haid Terakhir",
	"dueDatePage.lastPeriod.calculate": "Hitung",
	"dueDatePage.lastPeriod.lastPeriodLabel": "Hari Pertama dari Haid Terakhir Anda",
	"dueDatePage.lastPeriod.periodLengthLabel": "Durasi siklus haid",
	"dueDatePage.ultrasound": "Ultrasound",
	"dueDatePage.ultrasound.tooltip": "Mean sac Diameter (MSD) is less accurate than Crown-Rump Length (CRL) for dating a pregnancy. It is only used in very early pregnancy, between 4 and 6 weeks.",
	"dueDatePage.validation.crl": "The MSD value is invalid. Please enter the CRL metric to continue.",
	"dueDatePage.validation.one_is_required": "Setidaknya satu harus diisi",
	"dueDatePage.validation.record_not_valid": "Your recorded isn't valid!",
	"editor.addSocialLink.addLink": "Tambah",
	"editor.addSocialLink.warningDomain": "Hanya memperbolehkan sumber dari Youtube, Facebook, dan Tiktok",
	"expert.content.description": "Profil Pakar",
	"expert.content.experiences": "Pengalaman",
	"footer.signUp": "Daftar Sekarang",
	"gender.boy": "Laki-laki",
	"gender.female": "Perempuan",
	"gender.girl": "Perempuan",
	"gender.male": "Laki-laki",
	"healthToolPNModal.back": "Kembali",
	"healthToolPNModal.findMore.chooseFav": "Pilih dari topik favorit Anda",
	"healthToolPNModal.finish": "Selesai",
	"healthToolPNModal.heading": "Ingin mendapatkan newsletter gratis setiap minggu?",
	"healthToolPNModal.mainForm.requireName": "Masukkan nama Anda",
	"healthToolPNModal.mainForm.tailorTopicsHeading": "Topik-topik ini disesuaikan dengan hasil Anda",
	"healthToolPNModal.next": "Lanjutkan",
	"healthToolPNModal.register": "Daftar",
	"healthToolPNModal.yourPre": "Favorit Anda",
	"healthTools.dueDateCalculator": "Kalkulator Hari Perkiraan Lahir",
	"healthTools.ovulationCalculator": "Kalkulator Masa Subur",
	"healthtool.placeholder.age": "Usia Anda",
	"home.calcWithApp": "Hitung dengan Aplikasi Hello Sehat",
	"home.menu.category.view": "Tampilkan {category}",
	"home.navigator.app": "Aplikasi",
	"home.navigator.downloadApp": "Unduh Aplikasi",
	"home.navigator.menu.care.homeButton": "Booking Home",
	"home.navigator.menu.care.noDatas.cta": "Booking doktor",
	"home.navigator.menu.care.noDatas.description": "Temukan dokter dan layanan medis yang tepat untuk kebutuhan kesehatan di mana pun Anda berada.",
	"home.navigator.menu.care.noDatas.title": "Buat Janji Temu Dokter",
	"home.navigator.menu.category.noDatas.cta": "Lihat sekarang ",
	"home.navigator.menu.category.noDatas.description": "Hello Sehat ingin menjadi sobat terpercaya bagi Anda dalam mengetahui informasi kesehatan demi hidup yang lebih sehat dan bahagia. ",
	"home.navigator.menu.category.noDatas.title": "Selamat datang di Hello Sehat ",
	"home.navigator.menu.healthTools.noDatas.cta": "Lihat selanjutnya ",
	"home.navigator.menu.healthTools.noDatas.description": "Alat kesehatan ini mudah digunakan dan dapat membantu memantau kondisi kesehatan Anda secara umum. ",
	"home.navigator.menu.healthTools.noDatas.title": "Alat Kesehatan ",
	"home.navigator.menu.lastestVideos": "Shorts Terbaru",
	"home.navigator.menu.podcasts": "Podcast",
	"home.navigator.menu.shorts": "Shorts",
	"home.navigator.menu.spotlightEcom": "Categories",
	"home.navigator.menu.spotlightHospitals": "Rumah Sakit Terpopuler",
	"home.navigator.menu.spotlightTools": "Alat Kesehatan Favorit",
	"home.navigator.menu.spotlights": "Galeri Fokus",
	"home.navigator.menu.spotlights.seeAll": "Lihat Fokus Lainnya",
	"home.navigator.menu.together.noPosts.cta": "Bergabung Komunitas Kami",
	"home.navigator.menu.together.noPosts.description": "Komunitas adalah ruang aman tempat Anda dapat terhubung dengan anggota lain, mengomentari topik yang Anda minati, dan menerima saran tepercaya dari pakar medis seputar masalah kesehatan yang penting.",
	"home.navigator.menu.together.noPosts.title": "Selamat Datang di Komunitas!",
	"home.navigator.menu.trendingPosts": "Postingan Utama",
	"home.navigator.menu.trendingPosts.seeMore": "Lihat selanjutnya",
	"home.navigator.menu.videos": "Video",
	"home.navigator.menuItem.allCategories": "Lihat Semua Kategori",
	"home.navigator.menuItem.allCommunities": "Lihat Semua Komunitas",
	"home.navigator.menuItem.allCommunitiesheadingTitle": "Temukan komunitas Anda",
	"home.navigator.menuItem.allHealthTools": "Lihat Semua",
	"home.navigator.menuItem.allSpecialties": "Semua spesialisasi",
	"home.navigator.menuItem.allSpotlight": "Lihat Fokus Lainnya",
	"home.navigator.menuItem.allVideos": "See All Videos",
	"home.navigator.menuItem.discover": "Kategori",
	"home.navigator.menuItem.healthCategories": "Kategori Kesehatan",
	"home.navigator.menuItem.healthTools": "Cek Kesehatan",
	"home.navigator.menuItem.healthToolsList": "Cek Kondisi",
	"home.navigator.menuItem.helloCare": "Booking Dokter",
	"home.navigator.menuItem.helloEcom": "Farmasi",
	"home.navigator.menuItem.helloTogether": "Komunitas",
	"home.navigator.menuItem.language": "Bahasa",
	"home.navigator.menuItem.new": "new",
	"home.navigator.menuItem.specialties": "Spesialisasi",
	"home.navigator.menuItem.spotlights": "Galeri Fokus",
	"home.navigator.menuItem.video": "Video",
	"home.navigator.menuItem.videoCategories": "Video Categories",
	"home.search": "Cari {site}",
	"home.seeAll": "Lihat Semua Kategori",
	"home.seeAllCategories": "Lihat Semua",
	"home.seeExpert": "Lihat profil lengkap dokter",
	"home.seeHospital": "Lihat profil lengkap rumah sakit",
	"home.seeMore": "Lihat lainnya",
	"home.seeMoreExperts": "Lihat Semua",
	"hospital.content.description": "Informasi Rumah Sakit",
	"inputComment.replyTo": "Balas ke {nama}",
	insert: insert,
	"label.latestPost": "Postingan terakhir ",
	"label.pinnedPost": "Postingan yang ditandai",
	"lead.empty.cancel": "Batal",
	"lead.empty.submitAgain": "Kirim lagi",
	"lead.empty.title": "Oops, sepertinya informasi Anda kosong. Apakah Anda ingin mengirimkan informasi lagi?",
	"leadgen.message.error.name_required": "Please enter your name",
	"leadgen.message.error.phone_invalid": "Please enter a valid phone number",
	loading: loading,
	"login.booking": "Booking dokter",
	"logout.popup.ask.mb": "Keluar dari Hello Sehat ",
	"logout.popup.ask1": "Keluar dari Hello Sehat?",
	"logout.popup.ask2": "Anda yakin mau keluar?",
	"logout.popup.button.cancel": "Batal",
	"logout.popup.button.logout": "Keluar",
	"menu.care.searchBySpecialties": "Cari berdasar spesialisasi",
	"morePopover.report": "Report",
	"morePopover.report.description": "Bantu kami mengidentifikasi masalah di postingan ini. Sampaikan keluhan Anda.",
	"morePopover.report.falseNews": "Informasi Palsu",
	"morePopover.report.offensive": "Menyerang Pihak Lain",
	"morePopover.report.other": "Lainnya",
	"morePopover.report.prohibited": "Konten Terlarag",
	"morePopover.report.scam": "Provokatif",
	"morePopover.report.sex": "Mengandung SARA",
	"morePopover.report.spam": "Spam",
	"morePopover.report.title": "Laporan postingan ini",
	"morePopover.report.violence": "Kekerasan",
	"morePopover.reportSubmit.description": "Kami tidak akan membuka pelapor. Periksa detail laporan Anda.",
	"morePopover.reportSubmit.title": "Posting laporan?",
	"morePopover.savePost": "Simpan postingan",
	"morePopover.share": "Bagikan",
	"morePopover.shareOn": "Bagikan ke",
	"morePopover.turnOffNotifications": "Matikan notifikasi",
	"morePopover.turnOnNotifications": "Nyalakan notifikasi",
	"morePopover.unsavePost": "Remove Saved post",
	"navigation.loginJoin": "Masuk",
	"navigation.search.input.placeholder": "Cari",
	"navigation.signUp": "Sign up",
	"newsletter.error.minCotennt": "Pilih setidaknya 1 topik untuk melanjutkan",
	"newsletter.error.minTitle": "Masukkan nama Anda",
	"newsletter.topic.title": "Topik kesehatan apa yang menarik bagi Anda?",
	"newsletter.welcome.description": "Apa nama panggilan Anda?",
	"notification.comment.blocked.message": "This comment contains banned words or phrases and won’t be published",
	"notification.comment.blocked.title": "Blocked comment",
	"notification.comment.premod": "Komentar Anda ditangguhkan.",
	"notification.comment.rejected": "Komentar Anda mengandung kata-kata yang bertentangan dengan kebijakan kami.",
	"notification.comment.reportFailed": "Gagal!",
	"notification.comment.reportSuccess": "Laporan Anda mengenai komentar ini berhasil.",
	"notification.comment.somethingWrong": "Terjadi kesalahan.",
	"notification.comment.suspect.message": "This comment contains suspected words or phrases and won’t be published",
	"notification.comment.suspect.title": "Pending comment",
	"notification.comment.systemWithheld": "Komentar Anda ditangguhkan.",
	"notification.failure": "Ada yang salah. Silakan coba lagi.",
	"notification.limitUrlDomain": "Cannot post link outside of Hello Health Group.",
	"notification.post.blocked.message": "This post contains banned words or phrases and won’t be published",
	"notification.post.blocked.title": "Blocked post",
	"notification.post.delete": "Post Deleted",
	"notification.post.suspect.message": "This post contains suspected words or phrases, and is placed for moderator review",
	"notification.post.suspect.title": "Pending post",
	"notification.success": "Success",
	"notification.suspend.message": "Akun Anda kami nonaktifkan karena telah melanggar ketentuan layanan kami.",
	"notification.urlWrongFormat": "Incorrect URL format",
	"onboarding.button.continue": "Lanjutkan ",
	"onboarding.button.skip": "Lewati ",
	"onboarding.errorMessage.invalidEmail": "Email salah ",
	"onboarding.errorMessage.minLength": "Tolong isi minimal {length} karakter ",
	"onboarding.errorMessage.passNotMatch": "Password harus sesuai ",
	"onboarding.errorMessage.passWithPattern": "Kata sandi mesti berisi huruf kapital dan huruf kecil ",
	"onboarding.errorMessage.requiredConfirmPassword": "Tolong konfirmasi kata sandi Anda ",
	"onboarding.errorMessage.requiredEmail": "Tolong isi dengan email Anda",
	"onboarding.errorMessage.requiredName": "Tolong isi dengan nama Anda",
	"onboarding.errorMessage.requiredPassword": "Tolong isi dengan kata sandi Anda",
	"onboarding.formEmail.description": "Gunakan email untuk melanjutkan ke Komunitas {site}. ",
	"onboarding.formEmail.genderFemale": "Perempuan ",
	"onboarding.formEmail.genderMale": "Laki-laki ",
	"onboarding.formEmail.heading": "Izinkan kami mengenalmu lebih baik. ",
	"onboarding.formEmail.yourBirthday": "Tanggal Lahir Anda",
	"onboarding.formEmail.yourEmail": "Email Anda",
	"onboarding.formEmail.yourName": "Nama Anda ",
	"onboarding.label.fullName": "Full name",
	"onboarding.otpForm.description": "Kami telah mengirimkan kode OTP ke nomor {phone}",
	"onboarding.otpForm.descriptionEmail": "Kami telah mengirimkan kode OTP ke email {phone}",
	"onboarding.otpForm.error": "Tolong isi dengan kode OTP ",
	"onboarding.otpForm.heading": "Masukkan kode OTP",
	"onboarding.otpForm.notReceiveOTP": "Tidak menerima kode OTP? ",
	"onboarding.otpForm.resendCode": "Kirim Ulang Kode",
	"onboarding.otpForm.resendCodeWithSeconds": "Kirim ulang dalam {seconds} detik",
	"onboarding.otpWhatsapps.description": "Kami telah mengirimkan One-Time Password (OTP) ke nomor WhatsApp Anda {phone}",
	"onboarding.otpWhatsapps.heading": "Verifikasi WhatsApp",
	"onboarding.similac.address.error": "Alamat harus diisi",
	"onboarding.similac.input.address": "Alamat",
	"onboarding.similac.input.city": "Masukkan provinsi",
	"onboarding.similac.input.district": "Masukkan kota atau kabupaten",
	"onboarding.similac.input.no": "Masukkan nama jalan, gedung, nomor rumah",
	"onboarding.similac.input.phone": "Nomor HP",
	"onboarding.similac.input.ward": "Masukkan desa atau kelurahan",
	"onboarding.updatePassword.confirmPassword": "Konfirmasi Kata Sandi ",
	"onboarding.updatePassword.description": "Pastikan kata sandi terdiri dari 8 karakter atau lebih ",
	"onboarding.updatePassword.heading": "Sedikit lagi! Kamu membutuhkan kata sandi. ",
	"onboarding.updatePassword.password": "Kata Sandi ",
	"onboarding.updatePasswordResult.description": "Sekarang kamu bisa masuk akun Hello Sehat dengan kata sandi baru. ",
	"onboarding.updatePasswordResult.heading": "Pengaturan kata sandi berhasil ",
	"onboarding.updatePhone.description": "Kami akan mengirimkan kode OTP ke nomor teleponmu",
	"onboarding.updatePhone.error": "Tolong isi dengan nomor telepon ",
	"onboarding.updatePhone.heading": "Nomor telepon",
	"onboarding.updateWhatsapp.description": "Whatsapp akan perlu memverifikasi nomor telepon Anda.",
	"onboarding.updateWhatsapp.submitLabel": "Lanjutkan dengan WhatsApp",
	"onboarding.welcomeScreen.content": "Ini merupakan wadah untuk kami berbagi, saling terhubung, dan saling memberi dukungan dengan member lainnya demi mewujudkan hidup yang lebih sehat dan bahagia. ",
	"onboarding.welcomeScreen.heading": "Selamat datang di Komunitas Hello Sehat",
	orCopyLink: orCopyLink,
	"ovulationPage.avoidPregnancy": "Mencegah kehamilan",
	"ovulationPage.conceive": "Merencanakan kehamilan",
	"ovulationPage.cycleLength": "Berapa lama siklus haid Anda?",
	"ovulationPage.dayUnit": "hari",
	"ovulationPage.objectives": "Berapa lama Anda haid?",
	"ovulationPage.periodDuration": "Berapa lama Anda haid?",
	"ovulationPage.trackPeriod": "Pantau siklus haid",
	"placeholder.enterTitleHere": "Masukkan judul",
	"placeholder.enterUrlHere": "Masukkan URL",
	"placeholder.enterUrlTextHere": "Masukkan teks URL",
	"placeholder.newCmt": "Tulis komentar",
	"placeholder.newPost": "Buat postingan baru",
	"pnBanner.both": "Keduanya",
	"pnBanner.both.desc": "Selamat datang di dunia parenting! Gunakan alat kesehatan sesuai dengan kebutuhan Anda.",
	"pnBanner.both.heading": "Pakai alat kesehatan kami untuk para orangtua!",
	"pnBanner.caclNow": "Hitung Sekarang",
	"pnBanner.checkNow": "Cek Sekarang!",
	"pnBanner.dueDateTool.desc": "Siapkan kedatangan si Kecil dengan mengetahui HPL Anda tanpa stres!",
	"pnBanner.dueDateTool.heading": "Sedang Hamil? Cek HPL Anda di Sini!",
	"pnBanner.hpv.desc": "Respons Anda akan membantu kami memberikan rekomendasi yang spesifik untuk kebutuhan Anda.",
	"pnBanner.hpv.heading": "Jaga anak perempuan Anda dari virus HPV",
	"pnBanner.parenting.desc": "Respons Anda akan membantu kami memberikan rekomendasi yang spesifik untuk kebutuhan Anda.",
	"pnBanner.parenting.heading": "Apa kelompok umur anak Anda?",
	"pnBanner.pn.btnLabel": "Newsletter Premium",
	"pnBanner.pregnancy.desc": "Masukkan ini untuk memastikan rekomendasi kami cocok dengan perjalanan baru yang menyenangkan Anda.",
	"pnBanner.pregnancy.heading": "Apakah Anda sedang menjelajahi dunia kehamilan?",
	"pnBanner.submit": "Kirim",
	"pnBanner.teenager": "Remaja",
	"pnBanner.teenager.heading": "Apa jenis kelamin anak Anda?",
	"pnBanner.toddlers": "Anak-anak",
	"pnBanner.vaccination.desc": "Lindungi si Kecil dengan jadwal vaksinasi yang disesuaikan!",
	"pnBanner.vaccination.heading": "Gunakan Alat Pengingat Jadwal Imunisasi Bayi dan Anak",
	"pnBanner.vaccine.btnLabel": "Pengingat Jadwal Imunisasi Bayi dan Anak",
	"pnModal.disclaimer": "Email ringkasan pertama Anda sudah dalam perjalanan. Bersiaplah untuk menyelami konten yang dirancang khusus untuk Anda!",
	"pnTopicSection.maxSelectError.desc": "Hapus setidaknya 1 topik untuk melanjutkan",
	"pnTopicSection.maxSelectError.detail": "Pilih maksimal {max} topik {{maxTopic}}",
	"pnTopicSection.maxSelectError.title": "Maksimal {maxSelect} topik tercapai",
	"pnTopicSection.notFound": "Tidak ditemukan",
	"pnTopicSection.plsEnterFavTopics": "Masukkan topik favorit",
	"pnTopicSection.ppAlsoInterested": "Juga Berminat",
	"pnTopicSection.recentView": "Baru saja dilihat",
	"pnTopicSection.trending": "Trending",
	"popup.allTopics": "Semua topik",
	"popup.createPost.confirmCloseDescription": "Anda akan kehilangan postingan ini kalau keluar",
	"popup.createPost.confirmCloseTitle": "Postingan sudah aman?",
	"popup.deleteComment.description": "Komentar yang sudah dihapus tidak dapat dibatalkan",
	"popup.deleteComment.title": "Hapus komentar?",
	"popup.deletePost.accept": "Hapus ",
	"popup.deletePost.cancel": "Batal ",
	"popup.deletePost.description": "Postingan yang sudah dihapus tidak dapat dibatalkan ",
	"popup.deletePost.title": "Hapus postingan?",
	"popup.discardPost": "Hapus Postingan",
	"popup.discardPostEdit": "Discard changes",
	"popup.editPost": "Edit postingan",
	"popup.keepEditing": "Lanjut Mengedit",
	"popup.startANewPost": "Buat postingan baru",
	"post.commentCount": "{count} komen",
	"post.likesCount": "suka",
	"post.remove.failed": "Penghapusan gagal",
	"post.remove.success": "Hapus postingan yang disimpan",
	"post.save.failed": "Gagal menyimpan postingan",
	"post.save.success": "Postingan tersimpan",
	"post.seeMore": "Lihat Lainnya",
	"post.shareCount": "Bagikan ke",
	"pregnancy.week": "Minggu",
	"pregnancyTool.description": "Bayi Anda kini sebesar <fruitName>",
	"pregnancyTool.title": "Minggu kehamilan Anda ",
	"pregnancyTool.weightSuggested": "Berat badan yang disarankan ",
	"pregnancyWeightGain.havingTwins": "Apakah Anda anak kembar?",
	"pregnancyWeightGain.heading": "Penambahan Berat Badan Kehamilan",
	"pregnancyWeightGain.heightInput": "Berapa tinggi badan Anda?",
	"pregnancyWeightGain.weekInput": "Berapa minggu waktu kehamilan Anda?",
	"pregnancyWeightGain.weightBeforeInput": "Berapa berat badan Anda sebelum hamil?",
	"pregnancyWeightGain.weightInput": "Berapa berat badan Anda sekarang?",
	"pregnancyWeightGain.weightInput.desc": "(kg)",
	"pregnancyWeightGain.weightInput.error": "Masukkan berat badan Anda",
	"previewPhotos.title": "Postingan {name}",
	"profilePanel.anserwing.viewFull": "Lihat jawaban lengkap",
	"profilePanel.awards": "Penghargaan dan akreditasi ",
	"profilePanel.createPost": "Buat postingan",
	"profilePanel.education": "Pendidikan ",
	"profilePanel.emptyCareMess.content": "Sepertinya saat ini tidak ada pertanyaan untuk dokter. Terima kasih telah menjadi bagian dari komunitas kami.",
	"profilePanel.emptyPostMess.content": "{name} belum terlibat dalam kegiatan apapun belakangan ini.",
	"profilePanel.experience": "Pengalaman ",
	"profilePanel.joined": "Bergabung",
	"profilePanel.modal.heading": "Profil ",
	"profilePanel.publishcation": "Publikasi ",
	"profilePanel.publishedArticles": "Artikel di Hello Sehat ",
	"profilePanel.question": "Pertanyaan",
	"profilePanel.questionNotClear": "Pertanyaan kurang jelas ",
	"profilePanel.skipQuestion.content": "Kami akan menghapus pertanyaan ini ",
	"profilePanel.skipQuestion.heading": "Lewati pertanyaan ini ",
	"profilePanel.socialLinks": "Tautan sosial",
	"profilePanel.tabs.care": "Pertanyaan ",
	"profilePanel.tabs.expertAnswer": "Jawaban pakar ",
	"profilePanel.tabs.highlight": "Kredensial & fokus ",
	"profilePanel.tabs.posts": "Pos",
	"profilePanel.tabs.relevantArticles": "Artikel terkait ",
	"pwg.placeholder.height": "Tinggi (cm)",
	"pwg.placeholder.weight": "Berat (kg)",
	"pwgForm.week": "minggu",
	"sensitiveMask.blur": "Kaburkan",
	"sensitiveMask.contentWarningDescription": "Peringatan: Gambar berikut bisa jadi mengganggu bagi Anda. Kebijaksanaan pemirsa disarankan",
	"sensitiveMask.contentWarningDescription.community": "Peringatan: Gambar ini dapat mengganggu.",
	"sensitiveMask.contentWarningMessage": "Gambar-gambar ini bisa jadi mengganggu Anda...",
	"sensitiveMask.unblur": "Tunjukkan",
	"share.by": "Bagikan melalui",
	"share.copyLink": "Atau salin tautan",
	"share.letsJoinCommunity": "Ayo bergabung di komunitas {name}",
	"share.letsJoinTopic": "Let's join {name} topic!",
	"share.linkCopied": "Tautan Disalin",
	"share.linkShared": "Tautan Berhasil Dibagikan",
	"share.title": "Bagikan",
	"shareContainer.title": "Bagikan Hasil",
	"similac.thankYou.done": "Done",
	"ssov2.abTestingFlowB.description": "Daftar atau masuk dengan akun email atau media sosial Anda.",
	"ssov2.button.cancel": "Batal",
	"ssov2.button.continue": "Lanjutkan",
	"ssov2.button.continueGoogle": "Continue with Google",
	"ssov2.button.continueSMS": "Lanjutkan dengan SMS",
	"ssov2.button.continueWhatsApp": "Lanjutkan dengan WhatsApp",
	"ssov2.button.continueZalo": "Lanjutkan dengan Zalo",
	"ssov2.button.exitNow": "Saya ingin keluar sekarang",
	"ssov2.button.otp.sms": "Kirim kode OTP melalui SMS",
	"ssov2.button.otp.whatsapp": "Kirim kode OTP melalui WhatsApp",
	"ssov2.button.otp.zalo": "Kirim kode OTP melalui Zalo",
	"ssov2.button.save": "Simpan",
	"ssov2.button.setupLater": "Atur Lain Kali",
	"ssov2.collectInfo.why": "Mengapa kami memerlukan informasi Anda?",
	"ssov2.email.alreadyUsed": "Email ini sudah digunakan. Mohon pakai email lain.",
	"ssov2.email.button": "Verifikasi Email Anda",
	"ssov2.email.description": "Gunakan email Anda untuk masuk atau daftar",
	"ssov2.email.title": "Lanjutkan dengan email",
	"ssov2.error.api": "Kesalahan API",
	"ssov2.error.api.000": "Ada Kesalahan",
	"ssov2.error.api.001": "Email harus berupa alamat email yang valid.",
	"ssov2.error.api.002": "Kolom email wajib diisi.",
	"ssov2.error.api.003": "Member ini belum ada",
	"ssov2.error.api.004": "Email tidak boleh lebih dari 255 karakter.",
	"ssov2.error.api.005": "Kolom nomor HP wajib diisi.",
	"ssov2.error.api.006": "Nomor HP minimal harus 9 karakter.",
	"ssov2.error.api.007": "Nomor HP ini sudah ditautkan ke profil Anda.",
	"ssov2.error.api.008": "Kolom kode OTP wajib diisi.",
	"ssov2.error.api.009": "Pengguna tidak memperbarui",
	"ssov2.error.api.010": "Verifikasi OTP gagal",
	"ssov2.error.api.011": "Nama harus berupa teks.",
	"ssov2.error.api.012": "Nama tidak boleh lebih dari 100 karakter.",
	"ssov2.error.api.013": "Username harus berupa teks.",
	"ssov2.error.api.014": "Username telah diambil.",
	"ssov2.error.api.015": "Username tidak boleh lebih dari 20 karakter.",
	"ssov2.error.api.016": "Tanggal lahir tidak sesuai dengan format tahun-bulan-tanggal.",
	"ssov2.error.api.017": "Avatar wajib diisi.",
	"ssov2.error.api.018": "Avatar harus berupa gambar.",
	"ssov2.error.api.019": "Avatar harus berupa berkas berformat: jpeg, jpg, png, gif.",
	"ssov2.error.api.020": "Avatar tidak boleh lebih besar dari 10240 KB.",
	"ssov2.error.api.021": "Kolom konfirmasi kata sandi wajib diisi.",
	"ssov2.error.api.022": "Konfirmasi kata sandi harus terdiri dari minimal 8 karakter.",
	"ssov2.error.api.023": "Format konfirmasi kata sandi tidak valid.",
	"ssov2.error.api.024": "Konfirmasi kata sandi tidak boleh lebih dari 50 karakter.",
	"ssov2.error.api.025": "Kolom kata sandi baru wajib diisi.",
	"ssov2.error.api.026": "Kata sandi baru harus minimal 8 karakter.",
	"ssov2.error.api.027": "Format kata sandi baru tidak valid.",
	"ssov2.error.api.028": "Kata sandi baru tidak boleh lebih dari 50 karakter.",
	"ssov2.error.api.029": "Kata sandi Anda tidak cocok. Silakan coba lagi.",
	"ssov2.error.api.030": "Kata sandi baru Anda harus berbeda dari yang sekarang.",
	"ssov2.error.api.031": "Kolom kata sandi baru wajib diisi.",
	"ssov2.error.api.032": "Kolom konfirmasi kata sandi baru wajib diisi.",
	"ssov2.error.api.033": "Kata sandi baru dan konfirmasi kata sandi baru harus cocok.",
	"ssov2.error.api.034": "Konfirmasi kata sandi baru harus minimal 8 karakter.",
	"ssov2.error.api.035": "Kata sandi baru harus minimal 8 karakter.",
	"ssov2.error.api.036": "Konfirmasi kata sandi baru tidak boleh lebih dari 50 karakter.",
	"ssov2.error.api.037": "Kata sandi baru tidak boleh lebih dari 50 karakter.",
	"ssov2.error.api.038": "Kata sandi saat ini salah.",
	"ssov2.error.api.039": "Kolom kata sandi wajib diisi.",
	"ssov2.error.api.040": "Tanda Tangan Token tidak dapat diverifikasi.",
	"ssov2.error.api.041": "Token telah kedaluwarsa",
	"ssov2.error.api.042": "Kolom token penyegaran wajib diisi.",
	"ssov2.error.api.043": "Kolom kode area wajib diisi.",
	"ssov2.error.api.044": "Email telah dipakai.",
	"ssov2.error.api.045": "Verifikasi Kode OTP Email Gagal",
	"ssov2.error.api.046": "Kolom kode wajib diisi.",
	"ssov2.error.api.047": "Nomor HP telah dipakai.",
	"ssov2.error.api.048": "Nomor tidak cocok dengan nomor HP yang Anda daftarkan.",
	"ssov2.error.api.049": "Pengguna sudah ada.",
	"ssov2.error.api.050": "Kolom website id wajib diisi.",
	"ssov2.error.api.051": "Kolom nama wajib diisi.",
	"ssov2.error.api.052": "Kolom tanggal lahir wajib diisi.",
	"ssov2.error.api.053": "Kolom jenis kelamin wajib diisi.",
	"ssov2.error.api.054": "Kolom provider wajib diisi.",
	"ssov2.error.api.055": "Kolom token wajib diisi.",
	"ssov2.error.api.056": "Kode telah dikirim ke email Anda.",
	"ssov2.error.api.057": "Email tidak ada.",
	"ssov2.error.api.058": "Anda memverifikasi nomor HP yang bukan milik Anda.",
	"ssov2.error.api.059": "Nomor HP yang dipilih tidak valid.",
	"ssov2.error.api.060": "Telepon tidak masuk.",
	"ssov2.error.api.061": "Nomor HP ini sudah ditautkan ke profil Anda.",
	"ssov2.error.api.062": "Kesalahan ZNS dengan msg_id yang hilang",
	"ssov2.error.api.063": "Verifikasi OTP hilang",
	"ssov2.error.api.064": "Kedaluwarsa pada harus berupa tanggal setelah 5 menit.",
	"ssov2.error.api.065": "Kode yang dipilih tidak valid.",
	"ssov2.error.api.066": "Kesalahan saat memperbarui pelacakan ZNS",
	"ssov2.error.api.067": "OTP WhatsApp gagal terkirim",
	"ssov2.error.api.068": "Kedaluwarsa pada harus berupa tanggal setelah 10 menit.",
	"ssov2.error.api.069": "Kode harus minimal 6 karakter.",
	"ssov2.error.api.070": "Kode tidak boleh lebih dari 10 karakter.",
	"ssov2.error.api.071": "Anda telah mencapai batas 3 kali percobaan verifikasi dalam 1 jam. Harap tunggu dan coba lagi nanti.",
	"ssov2.error.api.072": "Anda telah mencapai batas 5 kali percobaan verifikasi hari ini. Harap coba lagi besok.",
	"ssov2.error.api.073": "Kata sandi harus minimal 8 karakter.",
	"ssov2.error.api.074": "Format kata sandi tidak valid.",
	"ssov2.error.api.075": "Format konfirmasi kata sandi tidak valid.",
	"ssov2.error.api.076": "Kata sandi harus mengandung setidaknya satu angka.",
	"ssov2.error.api.077": "Konfirmasi kata sandi harus mengandung setidaknya satu angka. ",
	"ssov2.error.api.078": "Email tidak ada",
	"ssov2.error.api.079": "Terlalu banyak pesan",
	"ssov2.error.api.080": "Kode OTP yang dimasukkan tidak valid",
	"ssov2.error.api.082": "The password must contain at least one uppercase and one lowercase letter.",
	"ssov2.error.api.083": "Sent Whatsapp OTP failed",
	"ssov2.error.facebookLogin": "Masuk Facebook gagal",
	"ssov2.error.googleLogin": "Terjadi kesalahan saat masuk dengan Google",
	"ssov2.first.country.code": "Kode Negara",
	"ssov2.first.description": "Lanjutkan dengan nomor telepon, email, atau media sosial Anda untuk masuk atau daftar.",
	"ssov2.first.noAccountOrPass": "Anda tidak memiliki akun atau perlu mengatur kata sandi, silakan lanjutkan daftar.",
	"ssov2.first.search.country.all": "Semua Negara",
	"ssov2.first.search.country.placeholder": "Cari Negara/Wilayah",
	"ssov2.first.search.country.selected": "Pilihan Saat Ini",
	"ssov2.first.title.login": "Masuk",
	"ssov2.first.title.signup": "Daftar",
	"ssov2.orContinueWith": "Atau lanjutkan dengan",
	"ssov2.otp.email.description": "Masukkan 6 digit OTP yang dikirim ke email Anda <b>{email}</b>. Kode OTP akan kedaluwarsa dalam <b>10 menit</b>.",
	"ssov2.otp.email.title": "Verifikasi Email",
	"ssov2.otp.phone.description": "Masukkan 6 digit OTP yang dikirim ke nomor HP <b>{phone}</b> melalui <b>{method}</b>. Kode OTP akan kedaluwarsa dalam <b>10 menit</b>.",
	"ssov2.otp.phone.title": "Verifikasi Nomor HP",
	"ssov2.otp.resendQuestion": "Tidak terima kode OTP?",
	"ssov2.otp.resendText": "Kirim ulang dalam ({count}s)",
	"ssov2.otp.sendVia": "Kirim kode OTP melalui {method}",
	"ssov2.password.description": "Masuk dengan kata sandi Anda.",
	"ssov2.password.forgotPassword": "Lupa kata sandi?",
	"ssov2.password.reset": "Atur ulang",
	"ssov2.password.signIn": "Masuk",
	"ssov2.password.title1": "Selamat datang kembali!",
	"ssov2.password.title2": "Masukkan Kata Sandi",
	"ssov2.passwordForgotSetup.description": "Masukkan kata sandi dan informasi lainnya untuk menyelesaikan proses pendaftaran.",
	"ssov2.passwordForgotSetup.field.password.atLeast8Chars": "Minimal 8 karakter.",
	"ssov2.passwordForgotSetup.field.password.atLeastOneUpper": "Minimal satu huruf besar, satu huruf kecil, dan satu angka.",
	"ssov2.passwordForgotSetup.field.password.label": "Kata sandi",
	"ssov2.passwordForgotSetup.field.password.placeholder": "Masukkan kata sandi Anda",
	"ssov2.passwordForgotSetup.field.passwordConfirm.label": "Konfirmasi Kata Sandi",
	"ssov2.passwordForgotSetup.field.passwordConfirm.placeholder": "Konfirmasi Kata Sandi",
	"ssov2.passwordForgotSetup.title": "Masukkan kata sandi Anda",
	"ssov2.phone.alreadyUsed": "Nomor HP sudah digunakan.Mohon pakai nomor HP lain.",
	"ssov2.phoneVerify.description": "Berikan informasi tambahan untuk menyelesaikan proses pendaftaran.",
	"ssov2.phoneVerify.title": "Verifikasi Nomor HP",
	"ssov2.policyText": "Dengan mendaftar, saya memastikan bahwa saya telah membaca, memahami, dan menyetujui {privacy} dan {terms} Hello Health Group. Saya setuju Hello Health Group mengumpulkan, menyimpan, menggunakan, mengungkapkan, dan memproses informasi saya sesuai dengan Kebijakan Privasi Hello Health Group. Selanjutnya, saya setuju Hello Health Group menggunakan informasi saya untuk mengirimi saya perihal promosi (termasuk melalui surat langsung, email, telepon, dan SMS) atau menghubungi saya tentang produk, layanan, program, atau topik lainnya yang menurut Hello Health Group mungkin menarik bagi saya; dan Hello Health Group dapat membagikan informasi saya ke mitra dan kliennya agar mereka dapat memberikan layanan dan informasi promosi yang lebih bermanfaat.",
	"ssov2.policyText.community": "Dengan mendaftar, saya menyatakan bahwa saya telah membaca, memahami, dan menyetujui {privacy} dan {terms} Hello Health Group. Saya setuju untuk bergabung dengan komunitas Hello Sehat, dan saya setuju Hello Health Group untuk mengumpulkan, menyimpan, menggunakan, mengungkapkan, dan memproses informasi saya sesuai dengan Kebijakan Privasi Hello Health Group. Selain itu, saya menyetujui Hello Health Group untuk menggunakan informasi saya dan mengirimkan informasi promosi kepada saya (termasuk melalui direct mail atau pesan langsung, email, telepon, dan pesan teks) atau menghubungi saya tentang produk, layanan, program, atau topik lain yang menurut Hello Health Group mungkin menarik bagi saya; dan Hello Health Group dapat membagikan informasi saya kepada mitra dan kliennya agar mereka dapat memberikan layanan dan informasi promosi yang lebih bermanfaat.",
	"ssov2.policyText.privacy": "Kebijakan Privasi",
	"ssov2.policyText.terms": "Ketentuan Pengguna ",
	"ssov2.popup.close.description": "Selangkah lagi untuk menyelesaikan pengaturan akun Anda. Apakah Anda benar-benar ingin keluar?",
	"ssov2.popup.close.title": "Yakin ingin keluar?",
	"ssov2.resetPassword.description": "Tambahkan nomor HP Anda untuk membuat akun.",
	"ssov2.resetPassword.title": "Ubah Kata Sandi",
	"ssov2.setup.button.createAccount": "Buat Akun Baru",
	"ssov2.setup.button.veriyPhone": "Verifikasi Nomor HP",
	"ssov2.setup.description": "Mohon tambahkan informasi lain yang diperlukan untuk menyelesaikan proses pendaftaran akun.",
	"ssov2.setup.field.dob.label": "Tanggal Lahir",
	"ssov2.setup.field.dob.placeholder": "Masukkan Tanggal Lahir Anda",
	"ssov2.setup.field.email.label": "Email",
	"ssov2.setup.field.gender.female": "Perempuan",
	"ssov2.setup.field.gender.label": "Jenis Kelamin",
	"ssov2.setup.field.gender.male": "Laki-Laki",
	"ssov2.setup.field.name.label": "Nama",
	"ssov2.setup.field.name.placeholder": "Masukkan Nama Anda",
	"ssov2.setup.field.otp.label": "Terima OTP melalui",
	"ssov2.setup.field.phone.label": "Nomor HP",
	"ssov2.setup.title": "Hampir selesai!",
	"ssov2.updateEmail.button": "Verifikasi Email Anda",
	"ssov2.updateEmail.description": "Perbarui dan verifikasi email Anda untuk terus menggunakan layanan kami.",
	"ssov2.updateEmail.title": "Ubah Email Anda",
	"ssov2.useOtherMethod.email": "Akun ini belum mengaktifkan login dengan email. Silakan pilih metode login lainnya.",
	"ssov2.useOtherMethod.phone": "Akun ini belum mengaktifkan login dengan nomor telepon. Silakan pilih metode login lainnya.",
	"ssov2.validate.confirmPassword.match": "Kata sandi harus sama",
	"ssov2.validate.confirmPassword.required": "Konfirmasi kata sandi harus diisi",
	"ssov2.validate.dob.required": "Tanggal lahir harus diisi",
	"ssov2.validate.email.invalid": "Email tidak valid",
	"ssov2.validate.email.required": "Email harus diisi",
	"ssov2.validate.gender.oneOf": "Jenis kelamin harus laki-laki atau perempuan",
	"ssov2.validate.gender.required": "Jenis kelamin harus diisi",
	"ssov2.validate.name.required": "Nama harus diisi",
	"ssov2.validate.otp.required": "Metode OTP harus diisi",
	"ssov2.validate.password.required": "Kata sandi harus diisi",
	"ssov2.validate.phone.required": "Nomor HP harus diisi",
	submit: submit,
	"switchBtn.no": "Tidak",
	"switchBtn.yes": "Ya",
	"tab.about": "Tentang Kami",
	"tab.discussion": "Diskusi",
	"tab.topic": "Topik",
	"tagTopic.moreTopics": "{number} topik lainnya",
	"targetHearRate.heading": "Kalkulator Detak Jantung",
	"targetHeartRate.aerobicZone.note": "Aerobic Zone (olahraga sedang 3-5 hari seminggu)",
	"targetHeartRate.aerobicZone.title": "Aerobic Zone",
	"targetHeartRate.ageInput": "Tanggal lahir Anda ....",
	"targetHeartRate.ageInput.desc": " (tahun)",
	"targetHeartRate.ageInput.error": "Masukkan usia Anda",
	"targetHeartRate.heartRateInput": "Detak jantung istirahat Anda ....",
	"targetHeartRate.heartRateInput.desc": "(bpm/denyut per menit)",
	"targetHeartRate.heartRateInput.error": "Masukkan detak jantung istirahat Anda",
	"targetHeartRate.lowIntensity.note": "Intensitas Rendah (sedikit atau tidak olahraga sama sekali)",
	"targetHeartRate.lowIntensity.title": "Intensitas Rendah",
	"targetHeartRate.maximumIntensity.note": "Intensitas Maksimum (olahraga amat keras setiap hari)",
	"targetHeartRate.maximumIntensity.title": "Intensitas Maksimum",
	"targetHeartRate.moderateIntensity.note": "Intensitas Rata-Rata (olahraga/latihan ringan 1-3 hari seminggu)",
	"targetHeartRate.moderateIntensity.title": "Intensitas Rata-Rata",
	"targetHeartRate.optional": "(opsional)",
	"targetHeartRate.selectActive": "Seberapa aktif Anda sehari-hari?",
	"targetHeartRate.vigorousIntensity.note": "Intensitas Kuat (olahraga keras 6-7 hari seminggu)",
	"targetHeartRate.vigorousIntensity.title": "Intensitas Kuat",
	"tool.askChecking": "Saya mengecek untuk orang lain",
	"tool.selectPerson": "Anda mengecek untuk ....",
	"tool.selectPerson.other": "Orang lain",
	"tool.selectPerson.yourSelf": "Diri sendiri",
	"toolPage.toolReviewer": "Ditinjau oleh {expert_name} pada {date}",
	"tools.checkYourKidsInput.label": "Anda sedang mengecek untuk anak Anda?",
	"tools.checkYrs": "Apakah Anda memeriksa untuk diri Anda sendiri?",
	"tools.heading.on": "pada",
	"tools.heartRateRangeErr": "Silakan masukkan nilai antara {min} - {max} bpm",
	"tools.inputPlaceholder": "Contoh: {content}",
	"tools.requiredErrorMess.age": "Masukkan usia yang valid.",
	"tools.requiredErrorMess.gender": "Silakan masukkan jenis kelamin",
	"tools.selectBabyGender": "Apa jenis kelamin anak Anda?",
	"tools.selectGender": "Apa jenis kelamin Anda?",
	"tools.yearsOld": "tahun",
	"updatePost.popup.success": "Postingan telah berhasil diperbarui.",
	"userProfile.nav.card.eCom": "eShop",
	"userProfile.nav.card.ecom.DeliveryAddress": "Manage addresses",
	"userProfile.nav.card.ecom.manageOrders": "Manage orders",
	"userProfile.nav.card.ecom.voucher": "Voucher",
	"userProfile.nav.card.myBooking": "Pesanan Saya",
	"userProfile.nav.card.myCommunity": "Komunitas Saya",
	"userProfile.nav.card.myFamily": "Profil Anggota Keluarga",
	"userProfile.nav.card.myHealth": "Kesehatan Saya",
	"userProfile.nav.card.mySaved": "Tersimpan",
	"userProfile.nav.header.count.comments": "Komentar",
	"userProfile.nav.header.count.posts": "Postingan",
	"userProfile.nav.header.count.tools": "Peralatan",
	"userProfile.nav.header.points": "Poin",
	"userProfile.nav.header.viewProfile": "Lihat Profil Saya",
	"userProfile.nav.menu.accountSettings": "Atur akun",
	"userProfile.nav.menu.dataPrivacy": "Privasi Data",
	"userProfile.nav.menu.disableAccount": "Nonaktifkan Akun",
	"userProfile.nav.menu.help": "Bantuan",
	"userProfile.nav.menu.logout": "Keluar",
	"userProfile.nav.menu.password": "Kata Sandi",
	"userProfile.userRank.ambassador": "Ambasador",
	"userProfile.userRank.doctor": "Dokter",
	"userProfile.userRank.expert": "Ahli",
	"userProfile.userRank.influencer": "Influencer",
	"userProfile.userRank.member": "Member",
	"validation.error.requiredAgeGroup": "Your child is not in the required age group",
	"validation.error.requiredField": "Kolom ini wajib diisi",
	"verifyBotAnswer.confirmEndorse.accept": "Yes, endorse",
	"verifyBotAnswer.confirmEndorse.cancel": "No, cancel",
	"verifyBotAnswer.confirmEndorse.description": "Thank you for endorsing the answer",
	"verifyBotAnswer.confirmEndorse.heading": "Endorse this answer"
};

export { character, copied, copy, idTranslations as default, insert, loading, orCopyLink, submit };
